/* ---- Core ---- */
import { ref, readonly } from 'vue';

export function useSmsFormToggle(): unknown {
  /* ---- State ---- */
  const isSmsFormOpen = ref(false);

  /* ---- Handlers ---- */
  const openSmsForm = () => {
    isSmsFormOpen.value = true;
  };
  const closeSmsForm = () => {
    isSmsFormOpen.value = false;
  };

  /* ---- return reactive value of composable ---- */
  return { isSmsFormOpen: readonly(isSmsFormOpen), openSmsForm, closeSmsForm };
}
